import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const unAssignEventObjectsApi = createAsyncThunk(
  "auth/unAssignEventObjects",
  async (data, { rejectWithValue }) => {
    try {
      const { ID } = data
      const response = await AuthAxios.delete(
        apiRoutes.publicapiAction(`event-objects/${ID}`, 1), { data }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const unAssignEventObjectsSlice = createSlice({
  name: "unAssignEventObjects",
  initialState: { result: [], loading: false, error: null, message: "", total: 0 },
  extraReducers: (builder) => {
    builder.addCase(unAssignEventObjectsApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(unAssignEventObjectsApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.results?.result ?? [];
      state.message = action?.payload?.message;
      state.total = action?.payload?.count
    });
    builder.addCase(unAssignEventObjectsApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const unAssignEventObjectsreducer = unAssignEventObjectsSlice.reducer;
